export enum Language {
  EN = 'en',
  DE = 'de',
  NL_BE = 'nl_BE',
  NL_NL = 'nl_NL',
  NL = 'nl',
  NL_BE_HYPHEN = 'nl-be', // For translations system
  CN = 'cn',
  RU = 'ru',
  IT = 'it',
  FR = 'fr',
  JA = 'ja',
  ES = 'es',
}

/**
 * The languages a translated form field actually carries — the same set
 * `getTranslationValidation` builds and `initialTranslations` seeds, and a
 * superset of what `languagesOptions` offers in the language switcher.
 *
 * `Language` additionally holds the Dutch regional variants and the
 * translations-system-only `nl-be`, for which translation form fields have no
 * slot; typing a form's selected language as `Language` therefore produces
 * field paths (`name.nl-be`) the form type does not have.
 */
export const FORM_LANGUAGES = [
  Language.EN,
  Language.DE,
  Language.NL,
  Language.CN,
  Language.RU,
  Language.IT,
  Language.FR,
  Language.JA,
  Language.ES,
] as const;

export type FormLanguage = (typeof FORM_LANGUAGES)[number];

// Backend-compatible locales (excludes nl-be which backend rejects)
export const BackendCompatibleLocales = {
  EN: 'en',
  DE: 'de',
  NL: 'nl',
  NL_BE: 'nl_BE',
  NL_NL: 'nl_NL',
  CN: 'cn',
  RU: 'ru',
  IT: 'it',
  FR: 'fr',
  JA: 'ja',
  ES: 'es',
} as const;
